"use client";
import { styled, css } from "@mui/material/styles";
import { Location } from "@nxt-costco-com/forge-icons/icons/Location";
import { Warehouse } from "@nxt-costco-com/forge-icons/icons/Warehouse";
import { ICON_SIZE } from "./constants.js";
const MainContainer = styled("div")`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    text-wrap: wrap;
`;
const iconStyles = css`
    height: ${ICON_SIZE};
    width: ${ICON_SIZE};
`;
const StyledLocationIcon = styled(Location)`
    ${iconStyles}
`;
const StyledWarehouseIcon = styled(Warehouse)`
    ${iconStyles}
`;
export {
  MainContainer,
  StyledLocationIcon,
  StyledWarehouseIcon
};
